import { ApolloProviderApiDataAccess } from "@package/ui-apollo-components";
import { AppContainer } from "@package/ui-app";
import { ErrorBoundaryAirbrake } from "@package/ui-components";
import { ConfigApp } from "@package/ui-config";
import { useSelectorDisplay } from "@package/ui-redux";
import { Provider } from "react-redux";
import { CMS_APP_ENVIRONMENT } from "../constants/contants";
import { store } from "../store/store";
import { ContentSection } from "./Content/ContentSection";
import { Header } from "./Header/Header";
import { Sidebar } from "./Sidebar/Sidebar";
const {
  ENV_VAR_AUTH0_AUDIENCE,
  ENV_VAR_AUTH0_CLIENT_ID,
  ENV_VAR_AUTH0_DOMAIN,
  ENV_VAR_AUTH0_REDIRECT_URI,
  ENV_VAR_API_URI_BASE,
  ENV_VAR_API_ANALYTICS_URI_BASE,
  ENV_VAR_AIRBRAKE_PROJECT_ID,
  ENV_VAR_AIRBRAKE_PROJECT_KEY,
} = import.meta.env;

function Body() {
  const fullWidth = useSelectorDisplay((state) => state.display.fullWidth);

  return (
    <ApolloProviderApiDataAccess app={ConfigApp.cms}>
      <div className="flex grow justify-center min-w-0">
        <div className="grow" />
        <div className={`flex w-full ${fullWidth ? "" : "max-w-7xl"} min-w-0`}>
          <div className="flex-0">
            <Sidebar />
          </div>
          <div className="grow bg-slate-100 border-l border-slate-300 border-solid pb-4 min-w-0">
            <ContentSection />
          </div>
        </div>
        <div className="grow bg-slate-100" />
      </div>
    </ApolloProviderApiDataAccess>
  );
}

export function App() {
  return (
    <ErrorBoundaryAirbrake
      projectId={ENV_VAR_AIRBRAKE_PROJECT_ID}
      projectKey={ENV_VAR_AIRBRAKE_PROJECT_KEY}
    >
      <AppContainer
        auth={{
          authorizationParams: {
            audience: ENV_VAR_AUTH0_AUDIENCE,
            redirect_uri: ENV_VAR_AUTH0_REDIRECT_URI,
          },
          clientId: ENV_VAR_AUTH0_CLIENT_ID,
          domain: ENV_VAR_AUTH0_DOMAIN,
        }}
        config={{
          apollo: {
            name: "panoscape-cms",
          },
          app: ConfigApp.cms,
          baseUrlApi: ENV_VAR_API_URI_BASE,
          baseUrlApiAnalytics: ENV_VAR_API_ANALYTICS_URI_BASE,
          environment: CMS_APP_ENVIRONMENT,
        }}
      >
        <Provider store={store}>
          <div className="flex flex-col min-h-full">
            <Header />
            <Body />
          </div>
        </Provider>
      </AppContainer>
    </ErrorBoundaryAirbrake>
  );
}
